import { render, staticRenderFns } from "./MoreThanOneTag.vue?vue&type=template&id=2f02bd25&"
import script from "./MoreThanOneTag.vue?vue&type=script&lang=ts&"
export * from "./MoreThanOneTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports